<script setup lang="ts">
import { ref, onMounted, onUnmounted, nextTick } from 'vue';
import type { Photo } from '@/shared/apollo-api/__generated__/types';

interface Props {
  photo: Photo;
  alt?: string;
}

const props = defineProps<Props>();

const emit = defineEmits<{
  click: [photo: Photo];
  'event-show-review': [];
}>();

const observer = ref<IntersectionObserver | null>(null);

const click = () => {
  emit('click', props.photo);
};

const eventShow = () => {
  emit('event-show-review');
};

onMounted(() => {
  observer.value = new IntersectionObserver(([entry]) => {
    if (entry && entry.isIntersecting) {
      eventShow();
    }
  });
  
  // Use nextTick to ensure DOM element is available
  nextTick(() => {
    const element = document.querySelector('.photo-item');
    if (element && observer.value) {
      observer.value.observe(element);
    }
  });
});

onUnmounted(() => {
  if (observer.value) {
    observer.value.disconnect();
  }
});
</script>

<template>
  <div @click="click" :key="photo.key" class="photo-item">
    <img :src="photo.link.low" :alt="alt" />
  </div>
</template>

<style scoped lang="stylus">
.photo-item
  cursor pointer
  
  img
    height 145px
    width auto
    aspect-ratio 3/4
    object-fit cover
    border-radius 12px
</style>
